(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["ReactD3Treemap"] = factory(require("react"));
	else
		root["ReactD3Treemap"] = factory(root["React"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__383__) {
return 